// broadcast
export const BROADCAST_NICKNAME_VALIDATION_CHECK = "broadcast_nickname_validation_check";
export const BROADCAST_TOPBANNER_EXIST_CHECK = "broadcast_topbanner_exist_check";